import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRoutes = [

  {
    path: "/",
    component: () => import("../view/Home/index.vue"),
    meta: {
      title: "主页",
    },
  },
  {
    path: "/contact",
    component: () => import("../view/contactUs/index.vue"),
    meta: {
      title: "主页",
    },
  },
  {
    path: "/aboutUs",
    component: () => import("../view/AboutUs/index.vue"),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/webC",
    component: () => import("../view/introduce/index.vue"),
    meta: {
      title: "主页",
    },
  },
];

const createRouter = () =>
  new Router({
    mode: "hash", // require service support
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });

const router = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
